// author: Caleb Yearsley (caleb.yearsley@tecuity.com)
// date: 2019-07-30

import { cloneDeep } from "lodash";
import { SerializableError } from "../types";

export class ValidationError {

	private readonly serializableError: SerializableError;

	public constructor(serializableError: SerializableError) {

		this.serializableError = serializableError;
	}

	public getErrorDictionary = (): { [key: string]: string[] } => {

		const serializableError = cloneDeep(this.serializableError);
		delete serializableError.$type;

		return serializableError;
	}

	/**
	 * Returns a list of errors
	 */
	public getErrorList = (): string[] => {

		const errors: string[] = [];

		for (const key in this.serializableError) {

			if (key !== "$type") {

				errors.push(...this.serializableError[key]);
			}
		}

		return errors;
	}

	/**
	 * Returns a list of errors prefixed by their key
	 */
	public getKeyedErrorList = (): string[] => {

		const errors: string[] = [];

		for (const key in this.serializableError) {

			if (key !== "$type") {

				for (const error of this.serializableError[key]) {

					errors.push(`${key.replace(/___/g, " ").replace(key.charAt(0), key.charAt(0).toUpperCase())}: ${error}`);
				}
			}
		}

		return errors;
	}
}
